module.exports = __webpack_public_path__ + "img/vegetables-1.837f2108.jpg";